import { t } from '@lingui/core/macro';
import { useEffect } from 'react';

import { useHeaderContext } from './HeaderContext';

type Props = {
  children: string;
  exampleAIQuestions?: string[];
  hideHeaderTitle?: boolean;
};

const HeaderSetter = ({ children, exampleAIQuestions, hideHeaderTitle = false }: Props) => {
  const { setTitle, setExampleAIQuestions } = useHeaderContext();

  useEffect(() => {
    if (!hideHeaderTitle) {
      setTitle(children);
    }

    if (children) {
      document.title = children;
    } else {
      document.title = t`Channel99`;
    }

    return () => {
      setTitle(null);
    };
  }, [children, hideHeaderTitle, setTitle]);

  useEffect(() => {
    if (exampleAIQuestions) {
      setExampleAIQuestions(exampleAIQuestions);
    }
  }, [exampleAIQuestions, setExampleAIQuestions]);

  return null;
};

export default HeaderSetter;
